// extracted by mini-css-extract-plugin
export default {"Intro":"Intro_Intro__hb17E","center":"Intro_center__reBA6","left":"Intro_left__rfRt2","introduction":"Intro_introduction__DBKgJ"};